import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full border border-input bg-background px-4 py-3 text-sm outline-none focus:border-foreground transition-colors duration-200 rounded-none placeholder:text-muted-foreground/60";

export const ReactionModal = ({ property, open, onClose }) => {
  const [form, setForm] = useState({
    naam: "",
    email: "",
    telefoon: "",
    bericht: "",
  });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) setForm({ naam: "", email: "", telefoon: "", bericht: "" });
  }, [open, property]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/reactions`, {
        ...form,
        woning_id: property.id,
        woning_titel: `${property.title} — ${property.city}`,
      });
      toast.success("Reactie verstuurd!", {
        description: "We nemen binnen 24 uur contact met je op.",
      });
      onClose();
    } catch {
      toast.error("Versturen mislukt", {
        description: "Probeer het opnieuw of mail naar arthur@rentguru.nl.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="reaction-modal"
        className="rounded-none border border-foreground shadow-none sm:max-w-[520px] p-8"
      >
        <DialogHeader>
          <DialogDescription className="text-xs tracking-[0.25em] uppercase text-muted-foreground">
            Reageren op
          </DialogDescription>
          <DialogTitle className="font-display font-black text-2xl tracking-tight">
            {property ? `${property.title} — ${property.city}` : "Woning"}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <input
            data-testid="reaction-input-naam"
            required
            minLength={2}
            value={form.naam}
            onChange={set("naam")}
            placeholder="Naam *"
            className={inputCls}
          />
          <input
            data-testid="reaction-input-email"
            required
            type="email"
            value={form.email}
            onChange={set("email")}
            placeholder="E-mailadres *"
            className={inputCls}
          />
          <input
            data-testid="reaction-input-telefoon"
            value={form.telefoon}
            onChange={set("telefoon")}
            placeholder="Telefoonnummer (optioneel)"
            className={inputCls}
          />
          <textarea
            data-testid="reaction-input-bericht"
            required
            rows={4}
            value={form.bericht}
            onChange={set("bericht")}
            placeholder="Vertel kort over jezelf en je woonsituatie *"
            className={`${inputCls} resize-none`}
          />
          <button
            data-testid="reaction-submit-button"
            type="submit"
            disabled={sending}
            className="w-full bg-foreground text-background py-4 text-sm font-medium tracking-wide hover:bg-foreground/85 disabled:opacity-50 transition-colors duration-200"
          >
            {sending ? "Versturen…" : "Verstuur reactie"}
          </button>
          <p className="text-xs text-muted-foreground text-center">
            Liever direct mailen?{" "}
            <a
              data-testid="reaction-mail-link"
              href="mailto:arthur@rentguru.nl"
              className="underline underline-offset-2"
            >
              arthur@rentguru.nl
            </a>
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
};
